/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../../../stores/types/types';
import { startSpielbergBroadcast, stopSpielbergBroadcast } from '../../../../stores/actions/broadcasting';
import { RECORDING_OPTIONS } from '../../../broadcasting/constants';
import Switch from '../../../general-components/switch';
import { RoomStates } from '../../../../types/enums';
import { BroadcastAudioCodec, BroadcastVideoCodec, EgressDeployment } from '../../../../stores/types/broadcasting';

const DEPLOYMENT_LABELS: Record<EgressDeployment, string> = {
	cloud: 'LiveKit Cloud',
	self: 'Self-hosted',
};

export default function DebugBroadcast() {
	const dispatch = useDispatch();

	const spielbergBroadcast = useSelector((s: GS) => s.BroadcastReducer.spielbergBroadcast);
	const token = useSelector((s: GS) => s.SessionReducer.token);
	const meeting = useSelector((s: GS) => s.SessionReducer.meeting);
	const roomState = useSelector((s: GS) => s.MeetingReducer.roomState);
	const selectedRecordingOpt = useSelector((s: GS) => s.BroadcastReducer.selectedRecordingOption);
	const useDebugEncodingOptions = useSelector((s: GS) => s.DebugReducer.useDebugEncodingOptions);
	const debugEncodingOptions = useSelector((s: GS) => s.DebugReducer.debugEncodingOptions);
	const { use_spielberg: useSpielberg } = useSelector((s: GS) => s.SettingsReducer.featureFlags);

	const startBroadcast = () => {
		const isBroadcasting = selectedRecordingOpt === RECORDING_OPTIONS.STREAM_AND_RECORD;
		if (!token || !meeting) return;
		dispatch(
			startSpielbergBroadcast(
				token,
				meeting.meeting,
				isBroadcasting,
				true,
				useDebugEncodingOptions ? debugEncodingOptions : undefined,
			),
		);
	};

	const stopBroadcast = () => {
		if (!token || !meeting) return;
		dispatch(
			stopSpielbergBroadcast(
				token,
				meeting.meeting,
			),
		);
	};

	const handleChangeEncodingOption = (
		e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
	) => {
		const { name, value } = e.target;
		const numberValue = Number(value);
		if (Number.isNaN(numberValue)) return;
		dispatch({
			type: 'DEBUG_ENCODING_OPTIONS',
			payload: {
				...debugEncodingOptions,
				[name]: numberValue,
			},
		});
	};

	const getOptions = (key: string) => {
		const optionType = key === 'audioCodec' ? BroadcastAudioCodec : BroadcastVideoCodec;
		const options = Object.entries(optionType).filter(([, value]) => Number.isInteger(value));
		return (options.map(([, value], index) => (
			<option
				key={index}
				value={value}
			>
				{optionType[value]}
			</option>
		)));
	};

	return (
		<>
			<div className="section flex justify-content-space-between">
				<div>
					<h5>Spielberg Broadcast</h5>
					{spielbergBroadcast ? (
						<ul style={{
							padding: 0,
							margin: 0,
							listStyleType: 'none',
							marginBlockStart: 0,
						}}>
							<li><label style={{ color: '#A6FF79' }}>ID: </label>{spielbergBroadcast.id}</li>
							<li><label style={{ color: '#A6FF79' }}>PROVIDER: </label>{spielbergBroadcast.provider}</li>
							<li><label style={{ color: '#A6FF79' }}>EGRESS: </label>
								{spielbergBroadcast.egressDeployment
									? DEPLOYMENT_LABELS[spielbergBroadcast.egressDeployment]
									: 'unknown'}
							</li>
							<li><label style={{ color: '#A6FF79' }}>STATUS: </label>{spielbergBroadcast.status}</li>
							<li><label style={{ color: '#A6FF79' }}>START TIME: </label>
								{spielbergBroadcast.startTime && (
									new Date(spielbergBroadcast.startTime).toLocaleString()
								)}
							</li>
							<li><label style={{ color: '#A6FF79' }}>END TIME: </label>
								{spielbergBroadcast.endTime && (
									new Date(spielbergBroadcast.endTime).toLocaleString()
								)}
							</li>
						</ul>
					) : (
						<div style={{ fontStyle: 'italic' }}>No Spielberg Broadcast</div>
					)}
				</div>
					<div>
						<div>
							<button
								className="padding-small background-green text-dark border-radius-small"
								onClick={startBroadcast}
								title="Start Spielberg Broadcast"
								disabled={!useSpielberg || roomState !== RoomStates.live}
							>
								Start Spielberg Broadcast
							</button>
						</div>
						<div>
							<button
								className="padding-small background-green text-dark border-radius-small"
								onClick={stopBroadcast}
								title="Start Spielberg Broadcast"
								disabled={!useSpielberg || roomState !== RoomStates.live}
							>
								Stop Spielberg Broadcast
							</button>
						</div>
						<div className="align-items-center justify-content-end">
							<span>Use Debug Encoding: </span>
							<Switch
								on={useDebugEncodingOptions}
								onChange={() => dispatch({ type: 'USE_DEBUG_ENCODING_OPTIONS', payload: !useDebugEncodingOptions })}
								className={'green margin-left-small'}
							/>
						</div>
					</div>
			</div>
			{useSpielberg && (
					<div className="section margin-bottom-medium">
						<h5>Debug Encoding Options </h5>
						{Object.entries(debugEncodingOptions).map(([key, value], index) => (
							<div key={index} className="justify-content-space-between">
								<label>{key}: </label>
								{key === 'audioCodec' || key === 'videoCodec' ? (
									<select
										name={key}
										value={value}
										onChange={handleChangeEncodingOption}
									>
										{getOptions(key)}
									</select>
								) : (
									<input
										name={key}
										value={value}
										onChange={handleChangeEncodingOption}
									/>
								)}

							</div>
						))}
					</div>
			)}
		</>
	);
}
